import ConfigCmsApi from "../configs/ConfigCmsApi";
import ConfigBlogApi from "../configs/ConfigBlogApi";
import ConfigUsers from "../configs/ConfigUsers";
import Cookies from "js-cookie";

const alias = "/blog";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getArticles = (params) =>
  ConfigCmsApi.get(`${alias}/articles`, { params, headers: headers() });

const getArticle = (lang, articleAlias) =>
  ConfigCmsApi.get(`${alias}/article/${lang}/${articleAlias}`, { headers: headers() });

const upsertArticle = (data) =>
  ConfigCmsApi.post(`${alias}/articles`, data, { headers: headers() });

const deleteArticle = (lang, articleAlias) =>
  ConfigCmsApi.delete(`${alias}/article/${lang}/${articleAlias}`, { headers: headers() });

const translateArticle = (lang, articleAlias, targetLocales) =>
  ConfigCmsApi.post(`${alias}/article/${lang}/${articleAlias}/translate`, { target_locales: targetLocales }, { headers: headers() });

// Tags from blog-api microservice
const getTags = () =>
  ConfigBlogApi.get("/api/tags", { headers: headers() }).catch(() => ({ data: [] }));

// Users (employees) from users microservice
const getUsers = () =>
  ConfigUsers.get("api/v1/admin/users", { params: { type: "employee", per_page: 1000 }, headers: headers() }).catch(() => ({ data: [] }));

// Image upload/get via blog-api
// `files` is a map of blog-api image type -> File: main, preview, header_vertical, header_horizontal.
// Any subset is fine — blog-api keeps the stored URL for types that are not sent.
// (filePreview / fileMain kept for older callers.)
const addImage = ({ lang, articleAlias, files = {}, filePreview, fileMain }) => {
  const formData = new FormData();
  const all = { preview: filePreview, main: fileMain, ...files };
  Object.keys(all).forEach(type => {
    if (all[type]) formData.append(type, all[type]);
  });
  return ConfigBlogApi.post(`/api/admin/articles/${lang}/${articleAlias}/image`, formData, {
    headers: { ...headers(), "Content-Type": "multipart/form-data" },
  });
};

const getImage = (lang, articleAlias) =>
  ConfigBlogApi.get(`/api/admin/articles/${lang}/${articleAlias}/image`, { headers: headers() }).catch(() => ({ data: {} }));

export default {
  getArticles,
  getArticle,
  upsertArticle,
  deleteArticle,
  translateArticle,
  getTags,
  getUsers,
  addImage,
  getImage,
};
